import Axios from 'axios'
import { getPathName, getApiHash, getApiToken } from './helper';

const obtenerAniosPorVersion = async (marca: string, version:string, rubro = "Auto") => {
    const params = {
        hash: await getApiHash(),
        marca,
        version,
        rubro
    }
    const headers = { 
        'content-type': 'application/json',
        "Authorization" : 'Bearer ' + await getApiToken()
    }
    return await Axios.post(await getPathName() + "/GetAniosByVersionJSON", params,
        {
            headers: headers
        }).then(function (response) {
            return response.data.anios;
        }).catch(function (error) {
            return error;
    });
};

export default obtenerAniosPorVersion;